import $ from 'jquery'

var actionGear = function($element, options) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $gearTop,
      $gear;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $gear = $('.action_gear', $mainContainer);
    $gearTop = $('.gear_top_wrp', $mainContainer);

    if (options && options['confirmations_enabled']) { procConfirmationIfPresent(); }

    bindDomEvents();
  }

  function hideGear($elem) {
    $elem.removeClass('active');
    $elem.parents('.list_item, .action-cell').removeClass('zindex');
  }

  function bindDomEvents() {
    $gear.on('mouseenter', function() {
      var $this = $(this);
      $this.parents().find('.action_gear.active').removeClass('active');
      $this.parents().find('.zindex').removeClass('zindex');
      $this.addClass('active');
      $this.parents('.action-cell').addClass('zindex');
      $this.parents('.list_item').addClass('zindex');
    }).on('mouseleave', function() {
      var $this = $(this);
      $this.removeClass('active');
      $this.parents('.list_item').removeClass('zindex');
      $this.parents('.action-cell').removeClass('zindex');
    });

    $gear.on('focusin', function() {
      var $this = $(this);
      $this.addClass('active');
      $this.parents('.list_item').addClass('zindex');
      $this.parents('.action-cell').addClass('zindex');

      var $lastLink = $this.find('.gear_bottom li:visible:last').find('a, input:visible, button:visible');

      $lastLink.on('keydown', function(e) {
        if (e.keyCode == $.ui.keyCode.TAB && !e.shiftKey) {
          hideGear($this);
        }
      });

      $('.gear_top_inner').on('keydown', function(e) {
        if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
          hideGear($this);
        }
      });
    });

    $gear.on('click', function() {
      var $this = $(this);
      if($this.hasClass('active')) {
        $this.removeClass('active');
        $this.parents('.list_item').removeClass('zindex');
        $this.parents('.action-cell').removeClass('zindex');
      } else {
        $this.addClass('active');
        $this.parents('.list_item').addClass('zindex');
        $this.parents('.action-cell').addClass('zindex');
      }
    });

    $('a', $gearTop).on('click', function(e) {
      e.preventDefault();
    });
  }

  function procConfirmationIfPresent() {
    $gear.each(function(i, el){
      var $gear_el = $(el);
      $('li', $gear_el).each(function(i, li_el) {
        var $li_el = $(li_el);
        var $form = $('form', $li_el);
        $form.on('submit', function(event) {
          event.preventDefault();
          var $parent_li = $form.parent();
          var confirmation_text = $parent_li.data('confirmationText');
          if (confirmation_text) {
            SOPHIA.confirm(confirmation_text, function() { $form.off('submit'); $form.trigger('submit'); });
          }
        });
      });
    });
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
};

// jQuery plugin method
$.fn.actionGear = function(options) {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('actionGear')) {
      $this.data('actionGear', actionGear($this, options));
    }
  });
};
